import React, { useState, useEffect } from 'react';
import { ReactComponent as Dots } from '../images/dots.svg';
import { ReactComponent as Coin } from '../images/coin.svg';
import { formatMultiplier } from '../helpers/utils';
import { CurrentDetailCard } from './CurrentDetailCard';

export enum MultiplierTypes {
  points = 'points',
  miles = 'miles',
  cashback = 'cashback',
  percent = 'percent',
}

export enum MultiplierDisplayTypes {
  Default = 'default',
  MerchantCategory = 'merchant_category',
  DirectMerchant = 'direct_merchant',
}

const MultiplierTypesMap = new Map<string, string>([
  [MultiplierTypes.points, 'x'],
  [MultiplierTypes.miles, 'x'],
  [MultiplierTypes.cashback, '%'],
  [MultiplierTypes.percent, '%'],
])

export interface Multiplier {
  amount: number
  type: MultiplierTypes
  description: string
  display_type: MultiplierDisplayTypes
  category: string | null
  category_emoji: string | null
}

const formatMultiplier = (multiplier: Multiplier): string => {
  const formattedType = MultiplierTypesMap.get(multiplier.type) || '!'
  return `${multiplier.amount}${formattedType}`
}


function FloatingIcon({ user }: FloatingIconProps) : JSX.Element | null {
  const [isAnimating, setIsAnimating] = useState(false);
  const [showOrb, setShowOrb] = useState(true);
  const [showDetailCard, setShowCurrentDeailCard] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [bestCard, setBestCard] = useState<CardSearchResponseResult | null >({
    card: {
      name: "Chase Sapphire Preferred",
    },
    reason: "You deserve all the points, this one's on us!",
    multiplier: {
      type: MultiplierTypes.points,
      amount: 5,
    },
  });

  useEffect(() => {
    const animationCycle = () => {
      // Initial state - show orb
      setShowOrb(true);
      setShowCurrentDeailCard(false);
      setIsAnimating(false);
      setIsExpanded(false);

      // After 2s - expand the orb
      setTimeout(() => {
        setIsAnimating(true);
        setIsExpanded(true);

        // After 2s more - show card
        setTimeout(() => {
          setShowOrb(false);
          setShowCurrentDeailCard(true);
          setIsAnimating(false);
        }, 2000);
      }, 2000);
    };

    // Start first cycle
    animationCycle();

    // Repeat cycle every 8s (2s orb + 2s expanded + 4s card = 8s total)
    const intervalId = setInterval(animationCycle, 8000);

    return () => clearInterval(intervalId);
  }, []);

  const showCard = () => {
    return(
      <CurrentDetailCard
        bestCard={bestCard}
        closeCard={() => setShowCurrentDeailCard(false)}
      />
    )
  }

  const orb = () => {
    let fontSize = "font-base"
    if (bestCard) {
      const formatted = formatMultiplier(bestCard.multiplier)
      if (formatted.length > 3) {
        fontSize = "font-xsmall"
      }
    }
    return(
      <div
        className={`floatingIcon ${isExpanded ? 'expanded' : ''} ${isAnimating ? 'animating' : ''}`}

        onMouseEnter={() => setIsExpanded(true)}
        onMouseLeave={() => setIsExpanded(false)}
      >
        <div className="mainShape">
          <div className="goldCircle">
            <div
              className={`percentageText ${fontSize}`}
            >
              {formatMultiplier(bestCard.multiplier)}
            </div>
          </div>
          <Dots className="dotsSvg" />
          <div className="extraContent">
            <p>Miles</p>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div>
      {showOrb && (
        orb()
      )}
      {showDetailCard && (
        showCard()
      )}
    </div>
  )
}

export { FloatingIcon, formatMultiplier };
